import { TweenMax, TimelineMax } from 'gsap';

(function (global) {
  var Animations = {

    play(id, animationArray) {
      const animationObj = window.configMgr.getResourceFromArray(id, animationArray);

      // Return if id not exists in animations array define in config.json
      if (animationObj) {
        console.log(`play animation ${id}`);
        let tweens;
        let tween;
        // Support TimelineMax
        // https://greensock.com/docs/TimelineMax
        if (animationObj.mode === 'TimelineMax') {
          // TimeLine implementation
          const timeline = new TimelineMax({repeat: 0});
          // construct animation with all the tweens define in config.json
          tweens = animationObj.tweens;
          for (let i = 0; i < tweens.length; i++) {
            tween = tweens[i];
            timeline.add(TweenMax[tween.method](tween.target, tween.duration, tween.vars, tween.stagger, tween.position));
          }
          timeline.play();
        } else {
          // TweenMax for animation by default
          // https://greensock.com/docs/TweenMax
          tweens = animationObj.tweens;
          for (let i = 0; i < tweens.length; i++) {
            tween = tweens[i];
            TweenMax[tween.method](tween.target, tween.duration, tween.vars, tween.stagger, tween.position);
          }
        }
      }
    },
  };

  if (typeof exports === 'object') {
    module.exports = Animations;
  } else if (typeof define === 'function' && define.amd) {
    define(function () {
      return Animations;
    });
  } else {
    global.Animations = Animations;
  }
}(this));




// WEBPACK FOOTER //
// ./src/assets/js/animation.js